import React from "react";
import Select from "react-select";
import "./style.css";
import { useTranslation } from "react-i18next";

function CustomSelect({
  field,
  options = [],
  error,
  placeholder,
  onChange,
  isDisabled = false,
  isLoading = false,
}) {
  const { t } = useTranslation();
  const selectedOption = options.find((x) => x.value === field.value) ?? null;

  return (
    <>
      <Select
        className={`react-select-container${
          error ? " react-select-container--error" : ""
        }`}
        classNamePrefix="react-select"
        isDisabled={isDisabled}
        isLoading={isLoading}
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 1200,
          }),
          option: (base) => ({
            ...base,
            color: `#0f121f`,
          }),
        }}
        options={options}
        placeholder={placeholder ?? t("form.select")}
        value={selectedOption}
        onChange={(option) => {
          field.onChange(option ? option.value : option);
          onChange && onChange(option ? option.value : option);
        }}
        onBlur={field.onBlur}
        aria-invalid={error ? "true" : "false"}
      />
      {error && (
        <small className="uk-text-danger uk-display-block uk-margin-small-top">
          <span uk-icon="warning"></span>
          <span className="uk-margin-small-right uk-margin-small-left">
            {error.message}
          </span>
        </small>
      )}
    </>
  );
}

export default CustomSelect;
